export default{
  bind (el, elSource) {
    if(!elSource)
        elSource = el;
    elSource.style.cursor = 'move'
    el.style.position = 'fixed'
    el.mousedownPoint = {
      x: 0,
      y: 0
    }
    // bind 改变函数内部 this 指向，让 this 指向 el
    // el.handleMouseup, el.handleMousemove, el.handleMousedown 这三个可以是其他的全局变量
    el.handleMouseup = handleMouseup.bind(el)
    el.handleMousemove = handleMousemove.bind(el)
    el.handleMousedown = handleMousedown.bind(el)
    elSource.addEventListener('mousedown', el.handleMousedown)
    document.body.addEventListener('mouseup', el.handleMouseup)
    document.body.addEventListener('mousemove', el.handleMousemove)
  },
  unbind (el) {
    document.body.removeEventListener('mouseup', el.handleMouseup)
    document.body.removeEventListener('mousemove', el.handleMousemove)
  }
};
const handleMousedown = function (e) {
   // 这里的this被bind改变了，是el
   // 这里的e是 MouseEvent 对象
  const initialPosition = this.getBoundingClientRect()
  this.style.width = initialPosition.width + 'px'
  this.position = {
    left: initialPosition.left,
    top: initialPosition.top
  }
  this.readyToMove = true
  this.mousedownPoint.x = e.screenX
  this.mousedownPoint.y = e.screenY
}
const handleMousemove = function (e) {
  if (!this.readyToMove) return false;
  
  const position = this.position
  position.left = position.left + e.screenX - this.mousedownPoint.x
  position.top = position.top + e.screenY - this.mousedownPoint.y
  this.mousedownPoint.x = e.screenX
  this.mousedownPoint.y = e.screenY
  this.style.left = position.left + 'px'
  this.style.transform = 'none'
  this.style.marginLeft = 0
  this.style.marginTop = 0
  this.style.top = position.top + 'px'
  this.style.bottom = 'auto'
  this.style.right = 'auto'
  
  e.stopPropagation();
  e.preventDefault();
}
const handleMouseup = function (e) {
  this.readyToMove = false
}